import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MagnifyingGlass, MapPin } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

export function SearchBar({ categories = [], initial = {}, dark = false }) {
  const navigate = useNavigate();
  const [q, setQ] = useState(initial.q || "");
  const [location, setLocation] = useState(initial.location || "");
  const [category, setCategory] = useState(initial.category || "all");

  const submit = (e) => {
    e?.preventDefault();
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (location) params.set("location", location);
    if (category && category !== "all") params.set("category", category);
    navigate(`/jobs?${params.toString()}`);
  };

  return (
    <form
      onSubmit={submit}
      className="flex flex-col gap-2 rounded-2xl bg-white p-2.5 shadow-xl md:flex-row md:items-center"
      data-testid="job-search-bar"
    >
      <div className="flex flex-1 items-center gap-2 rounded-xl px-3 md:border-r md:border-border">
        <MagnifyingGlass size={20} className="text-muted-foreground" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Job title, keyword or company"
          className="h-11 w-full bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
          data-testid="search-keyword-input"
        />
      </div>
      <div className="flex flex-1 items-center gap-2 rounded-xl px-3 md:border-r md:border-border">
        <MapPin size={20} className="text-muted-foreground" />
        <input
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Town, city or postcode"
          className="h-11 w-full bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
          data-testid="search-location-input"
        />
      </div>
      <div className="md:w-52">
        <Select value={category} onValueChange={setCategory}>
          <SelectTrigger className="h-11 border-0 bg-transparent shadow-none focus:ring-0" data-testid="search-category-select">
            <SelectValue placeholder="Any category" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Any category</SelectItem>
            {categories.map((c) => (
              <SelectItem key={c} value={c}>{c}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <Button type="submit" className="h-11 rounded-xl px-8 text-sm" data-testid="search-submit-btn">
        Search Jobs
      </Button>
    </form>
  );
}
